import {  HttpEmpBiog   } from "../Http";
 
export class DocumentCaseAPI {
    public static  documentCaseCreate(input: any){
        var url = "documenttype/createDocumentTypeDetails/";
        var obj=JSON.stringify(input);

        if (input ==="") {
          return { data: [] };
        }
     
        const resultMethod = HttpEmpBiog.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
             
            return res;

          }).catch((e: any) => {
      
            return e.response;
          });
        return resultMethod; 
    }

    public static  documentCaseUpdate(input: any){
      var url = "documenttype/updateDocumentTypeDetails/";
      var obj=JSON.stringify(input);
     
      if (input ==="") {
        return { data: [] };
      }
      const resultMethod = HttpEmpBiog.axios().put(url, obj,
        {
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "*",
            "Access-Control-Allow-Headers": "*"
          }
        })
        .then(res => {
          
          return res;
        }).catch((e: any) => {
 
          return e.response;
        });
      return resultMethod;
  }
  public static  getAllDocumentCaseflows(input: any){
 
    var url = "documenttype/getAllDocumentType" ;  
  
     if (input ==="") {
       return { data: [] };
     }
  
     const resultMethod = HttpEmpBiog.axios()
       .get(url,  {
         headers: {
           "Content-Type": "application/json",
           "Access-Control-Allow-Origin": "*",
         }
       })
       .then(res => { 
        
         return res;
       })
       .catch((e: any) => {
         return e.response;
       });
     
     return resultMethod;  
  }

  public static  getAllDocumentCaseflowsById(input: any){
 
    var url = "documenttype/getDocumentTypeDetails/" + input.input;  
  
     if (input ==="") {
       return { data: [] };
     }
  
     const resultMethod = HttpEmpBiog.axios()
       .get(url,  {
         headers: {
           "Content-Type": "application/json",
           "Access-Control-Allow-Origin": "*",
         }
       })
       .then(res => { 
        
         return res;
       })
       .catch((e: any) => {
         return e.response;
       });
     
     return resultMethod;  
  }
  public static  getAllDocumentCaseflowsByUserId(input: any){
 
    var url = "documenttype/getDocumentTypeDetailsByCompanyIdAndUserName/" + input.input;  
    if(input.inputparam!=null){
        url = url+"?userName="+input.inputparam;  
    }
     if (input ==="") {
       return { data: [] };
     }
  
     const resultMethod = HttpEmpBiog.axios()
       .get(url,  {
         headers: {
           "Content-Type": "application/json",
           "Access-Control-Allow-Origin": "*",
         }
       })
       .then(res => { 
        
         return res;
       })
       .catch((e: any) => {
         return e.response;
       });
     
     return resultMethod;  
  }
}